<template>
  <v-layout
    row
    wrap
    class="ma-3"
  >
    <v-flex
      xs12
      md4
      v-if="country.capital"
    >
      <h3 class="body-2 grey--text">בירה</h3>
      <span class="title">{{ country.capital }}</span>
    </v-flex>
    <v-flex
      xs12
      md4
      v-if="country.phoneCode"
    >
      <h3 class="body-2 grey--text">קידומת בינלאומית</h3>
      <span
        class="title"
        dir="ltr"
      >{{ country.phoneCode }}</span>
    </v-flex>
    <v-flex
      xs12
      md4
      v-if="country.currencyCode"
    >
      <h3 class="body-2 grey--text">קוד מטבע</h3>
      <a
        :href="`https://www.google.com/search?q=1+${country.currencyCode}+in+ils`"
        target="_blank"
        class="title"
      >{{ country.currencyCode }}</a>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    country() {
      return this.$store.state.entities.countries[this.countryId];
    }
  },
  beforeMount() {},
  mounted() {},
  methods: {},
  props: ["countryId"],
  components: {},
  watch: {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/countries/country/CountryDetails.vue